





















import { Component, Vue } from 'vue-property-decorator';
import NotFound from '@/components/global/NotFound.vue';
import Loader from '@/components/global/Loader.vue';
import firebaseApp from '@/firebaseApp';
import PublicMenu from '@/components/public/PublicMenu.vue';
import Module from '@/components/global/Module.vue';
import { ModuleActions } from '@/models/Enums';

@Component({
  components: { Module, PublicMenu, Loader, NotFound },
})
export default class PublicClassroom extends Vue {
  public initiated = false;
  classroom: any = null;

  async mounted() {
    await this.getDashboard();
  }

  get moduleActions() {
    return [ModuleActions.Link];
  }

  async getDashboard() {
    const uuid = this.$route.params.uuid;
    const getClassRoomForUUID = firebaseApp
      .functions('europe-west3')
      .httpsCallable('getClassRoomForUUID');
    try {
      const result = await getClassRoomForUUID(uuid);
      console.log('resultresultresult', result);
      this.classroom = result.data;
    } catch (err) {
      console.error('Ophalen van dashboard niet gelukt', err);
    }

    this.initiated = true;
  }
}
